//import axios from 'axios';
import React,{Fragment, useEffect, useState} from 'react'
import { apiwebUrl } from '../utils';

function Empresasenvios() {
    const[servicio,setServicio]= useState([]);
    const traerServi = () =>{
        const url = apiwebUrl+"servicioenvios.php"
        fetch(url).then( respuesta => respuesta.json())
        .then(data=>{
            setServicio(data)
        })
    }
    
    useEffect(() => {
       traerServi()
    }, [])
    
  return (
    <Fragment>
         <div className='mt-5 bg-success p-5'>
            
            <div className='col-8 m-auto d-flex justify-content-between flex-wrap'>
            <h4 className='fw-light'>Nuestras empresas de envios</h4>
               <div className='d-flex justify-content-between flex-wrap w__full'>
                {
                        servicio.map(item =>(
                            <div className='col-3 w__full' key={item.idempresaenvio}>
                                <h2 className='fs-5'>{item.nombre}</h2>
                                <p>{item.telefono}</p>
                            </div>
                        ))
                    }
               </div>
            </div>
         </div>
    </Fragment>
  )
}

export default Empresasenvios